export function buildProfileQuestionsMap(questions) {
  const map = {};
  (questions || []).forEach((q) => {
    if (q?.questionId) {
      map[q.questionId] = `${q.surveyTitle}: ${q.questionText}`;
    }
  });
  return map;
}

export function formatQuotaCriteriaSummary(criteria = {}) {
  const parts = [];
  const fmt = (v) => (Array.isArray(v) ? v.join(', ') : (v || '—'));

  if (criteria.gender) parts.push(`Пол: ${fmt(criteria.gender)}`);
  if (criteria.ageRange) parts.push(`Возраст: ${criteria.ageRange.min}-${criteria.ageRange.max}`);
  if (criteria.regionScope) parts.push(`Охват: ${criteria.regionScope}`);
  if (criteria.region) parts.push(`Регион: ${fmt(criteria.region)}`);
  if (criteria.city) parts.push(`Город: ${fmt(criteria.city)}`);
  if (criteria.education) parts.push(`Образование: ${fmt(criteria.education)}`);
  if (criteria.employment) parts.push(`Занятость: ${fmt(criteria.employment)}`);
  if (criteria.maritalStatus) parts.push(`Семейное положение: ${fmt(criteria.maritalStatus)}`);
  if (criteria.hasChildren) parts.push(`Дети: ${fmt(criteria.hasChildren)}`);
  if (criteria.hasCar) parts.push(`Машина: ${fmt(criteria.hasCar)}`);

  return parts.join(' | ') || '—';
}

export function formatQuotaDynamicConditions(criteria = {}, profileQuestionsMap = {}) {
  const dynamic = Array.isArray(criteria.dynamic) ? criteria.dynamic : [];
  if (dynamic.length === 0) return '—';

  return dynamic
    .map((condition) => {
      const title = profileQuestionsMap[condition.questionId] || `Вопрос ${condition.questionId}`;
      const answers = Array.isArray(condition.answers) ? condition.answers.join(', ') : '';
      return `${title}: ${answers || '—'}`;
    })
    .join('\n');
}
